export default {"src":"/_next/static/media/white-north-arrow.083a86d6.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};